import React from 'react';
import style from './style.module.scss';
import Icon from 'components/Icon';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import cs from 'classnames';
import {ButtonNew} from 'components/ButtonNew';

type TFavouriteButtonProps = IProductSnippet['wishlist'];

export const FavouriteButton = (props: TFavouriteButtonProps) => {
    const {onAdd, onRemove, isAdded, isPending, positionIndex} = props;

    if (isAdded) {
        return (
            <ButtonNew
                className={style.root}
                variant={'unset'}
                theme={'ghost'}
                type={'button'}
                onClick={onRemove}
                isLoading={isPending}
                data-index={positionIndex}
            >
                <Icon icon={'favourite-fill'} className={cs(style.icon, style.icon_applied)} />
            </ButtonNew>
        );
    }

    return (
        <ButtonNew
            className={style.root}
            isLoading={isPending}
            variant={'unset'}
            theme={'ghost'}
            type={'button'}
            onClick={onAdd}
            data-index={positionIndex}
        >
            <Icon icon={'favourite'} className={style.icon} />
        </ButtonNew>
    );
};
